var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScientificCommunity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1189_7536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8335 36.958H29.1668",
    stroke: "#324D41",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 36.958V16.1247C4.16675 7.79134 6.25008 5.70801 14.5834 5.70801",
    stroke: "#324D41",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8334 36.958V16.1247C45.8334 7.79134 43.7501 5.70801 35.4167 5.70801",
    stroke: "#324D41",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 27.8125H10.0001C6.77842 27.8125 4.16675 30.4242 4.16675 33.6458V40.5C4.16675 43.7217 6.77842 46.3333 10.0001 46.3333H15.0001C18.2217 46.3333 20.8334 43.7217 20.8334 40.5V33.6458C20.8334 30.4242 18.2217 27.8125 15.0001 27.8125Z",
    stroke: "#00CE7C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 27.8125H35.0001C31.7784 27.8125 29.1667 30.4242 29.1667 33.6458V40.5C29.1667 43.7217 31.7784 46.3333 35.0001 46.3333H40.0001C43.2217 46.3333 45.8334 43.7217 45.8334 40.5V33.6458C45.8334 30.4242 43.2217 27.8125 40.0001 27.8125Z",
    stroke: "#00CE7C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1189_7536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScientificCommunity);
export default __webpack_public_path__ + "static/media/scientific_community.cc29d3038885c5ab0c3107f76eb9efd6.svg";
export { ForwardRef as ReactComponent };